var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider"},[_c('span',[_vm._v(_vm._s(_vm.text || _vm.$t('lbl_emp2_OR')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }